import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { OrganizationWorkflowApiService } from './organization-workflow-api.service';
import { ProcessTask } from './workflow-api.service';

@Component({
  standalone: true,
  selector: 'ain-organization-task-inbox',
  imports: [TableModule, ButtonModule, RouterLink],
  template: `
    <section class="feature-card">
      <h2>{{ t('organization.workflow.tasks.title') }}</h2>
      <p>{{ t('organization.workflow.tasks.description') }}</p>
      <p-table [value]="tasks()">
        <ng-template pTemplate="header">
          <tr><th>{{ t('columns.name') }}</th><th>{{ t('columns.status') }}</th><th></th></tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.name }}</td>
            <td>{{ row.status }}</td>
            <td><a [routerLink]="['/workflow/tasks', row.id]">{{ t('common.open') }}</a></td>
          </tr>
        </ng-template>
      </p-table>
    </section>
  `,
  styles: [`
    .feature-card { background: var(--ain-color-surface); border-radius: 16px; padding: 24px; box-shadow: 0 12px 30px rgb(15 23 42 / 8%); }
    a { color: var(--ain-color-primary); font-weight: 600; }
  `]
})
export class OrganizationTaskInboxComponent implements OnInit {
  private readonly api = inject(OrganizationWorkflowApiService);
  private readonly localization = inject(LocalizationService);
  readonly tasks = signal<ProcessTask[]>([]);

  ngOnInit(): void {
    this.api.getInbox().subscribe({ next: items => this.tasks.set(items) });
  }

  t(key: string): string { return this.localization.translate(key); }
}

